import React from 'react';
import { Button } from './ui/button';
import { Mail, MapPin } from 'lucide-react';

const CTA = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="relative rounded-3xl overflow-hidden">
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src="https://images.unsplash.com/photo-1462899006636-339e08d1844e?w=1200&q=80"
              alt="Partnership Opportunity"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 to-indigo-900/95"></div>
          </div>

          {/* Content */}
          <div className="relative px-8 py-20 md:px-16 md:py-24 text-center">
            <div className="max-w-4xl mx-auto">
              <div className="inline-block mb-6">
                <span className="px-4 py-2 bg-white/20 backdrop-blur-sm text-white rounded-full text-sm font-semibold">
                  Strategic Partnership Opportunity
                </span>
              </div>
              
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Transform Cultural Complexity Into Systematic Competitive Advantage
              </h2>
              <p className="text-xl text-blue-100 mb-10 leading-relaxed">
                Improve Business Ethics, Transparency & Cultural Intelligence through next-generation governance infrastructure with proven 90%+ accuracy across 47 jurisdictions.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                <a
                  href="mailto:partnerships@gaas-platform.com"
                  className="inline-flex items-center justify-center px-8 py-4 bg-white text-blue-600 hover:bg-gray-100 font-semibold rounded-lg transition-all duration-200 hover:shadow-xl hover:scale-105"
                >
                  <Mail className="mr-2 w-5 h-5" />
                  partnerships@gaas-platform.com
                </a>
              </div>

              {/* Location & Info */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white/80">
                <div className="flex items-center gap-2">
                  <MapPin className="w-5 h-5" />
                  <span>London, United Kingdom</span>
                </div>
                <div className="hidden sm:block w-1 h-1 bg-white/50 rounded-full"></div>
                <span>EMEA & APAC Governance Intelligence</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;